"use client";
import React from "react";
import Banner from "./Banner";
import Slider from "react-slick";
import { SETTINGS } from "./constants";

const BannerSection = ({ data }) => {
    return (
        <div className={"relative"}>
            {data?.images?.length > 1 ? (
                <Slider {...SETTINGS} dots={true}>
                    {data?.images?.map((item, index) => (
                        <Banner key={index} data={item} />
                    ))}
                </Slider>
            ) : (
                <Banner data={data?.images?.[0] || data} />
            )}
        </div>
    );
};

export default BannerSection;
